const mediaItems = [
  {
    title: '《星辰大海》终极预告',
    tag: '科幻',
    views: '128万次播放',
    desc: '浩瀚宇宙中的冒险传奇，特效与剧情双在线',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20spaceship%20in%20deep%20space%2C%20dramatic%20warm%20lighting%20with%20coral%20and%20orange%20nebula%20colors%2C%20epic%20composition%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20aesthetic%2C%20dark%20atmospheric%20background%20with%20stars%2C%20cinematic%20widescreen%20ratio%2C%20high%20contrast%20dramatic%20scene&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '暑期档综艺高光合集',
    tag: '综艺',
    views: '96万次播放',
    desc: '笑点密集！这个夏天最好笑的综艺名场面',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20warm%20spotlights%20and%20cheerful%20atmosphere%2C%20entertainment%20show%20set%20design%20with%20coral%20and%20amber%20color%20palette%2C%20lively%20composition%2C%20professional%20TV%20production%20style%2C%20clean%20stage%20background%20with%20decorative%20elements%2C%20high%20quality%20broadcast%20photography&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '高分纪录片《极限冒险家》',
    tag: '纪录片',
    views: '73万次播放',
    desc: '镜头下的极致自然奇观，每一帧都是壁纸',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20dramatic%20mountain%20landscape%20at%20golden%20hour%2C%20warm%20sunset%20light%20casting%20long%20shadows%2C%20cinematic%20aerial%20photography%20style%2C%20epic%20wide%20angle%20composition%2C%20rich%20coral%20and%20amber%20sky%20colors%2C%20professional%20documentary%20film%20aesthetic&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line"></i>
            <span className="whitespace-nowrap">热门精选</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">精彩视频</h2>
          <p className="mt-2 text-sm text-foreground-500">精选热播内容，精彩不容错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/25 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-800 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1.5">{item.desc}</p>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}